import React from "react";
import { motion } from "framer-motion";

const Featured = () => {
  const features = [
    {
      title: "Seamless Connections",
      desc: "Stay in touch with friends, family, and like-minded people with just a tap.",
      icon: "🔥",
    },
    {
      title: "Share Your Story",
      desc: "Upload photos, videos, and updates to let the world know what's happening in your life.",
      icon: "📸",
    },
    {
      title: "Real-Time Chat",
      desc: "Whether it's a DM or a group conversation, connect instantly with smooth, lightning-fast messaging.",
      icon: "💬",
    },
    {
      title: "Privacy First",
      desc: "Your data, your control. We prioritize your privacy with world-class security.",
      icon: "🔒",
    },
    {
      title: "Discover & Explore",
      desc: "Find trending content, join communities, and follow pages that match your interests.",
      icon: "🌍",
    },
    {
      title: "Grow Your Business",
      desc: "Use our platform to market your brand, connect with customers, and build meaningful relationships.",
      icon: "💼",
    },
  ];

  // Animation Variants for Smooth View
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <section className="bg-bggraycolor font-avant py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: -10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-[#2D2D2D] mb-4 tracking-tight"
          >
            Features That Keep You Hooked!
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-zinc-500 text-lg font-medium"
          >
            Meet, Chat, Share – Anytime, Anywhere!
          </motion.p>
        </div>

        {/* Features Grid - Exact Match to Screenshot */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.02 }}
              className="
          p-10 rounded-[2.5rem] text-center flex flex-col items-center justify-center
            bg-bggraycolor
            border border-white/60
            shadow-[inset_0_2px_2px_rgba(255,255,255,0.8),_5px_5px_15px_rgba(255,255,255,1),5px_5px_10px_rgba(0,0,0,0.3)]
            transition-all duration-500
              "
            >
              {/* Icon & Title Row */}
              <div className="flex items-center justify-center gap-3 mb-4">
                <span className="text-2xl">{feature.icon}</span>
                <h3 className="text-xl font-bold text-[#2D2D2D] tracking-tight">
                  {feature.title}
                </h3>
              </div>

              {/* Description */}
              <p className="text-zinc-500 leading-relaxed text-[15px] md:text-base px-2">
                {feature.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Featured;
